var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmpty, IsString } from 'class-validator';
export var CompanyLoginValidationMessageKey;
(function (CompanyLoginValidationMessageKey) {
    CompanyLoginValidationMessageKey["REQUIRED_COMPANY_ID"] = "REQUIRED_COMPANY_ID";
    CompanyLoginValidationMessageKey["REQUIRED_COMPANY_PASSWORD"] = "REQUIRED_COMPANY_PASSWORD";
    CompanyLoginValidationMessageKey["REQUIRED_USERNAME"] = "REQUIRED_USERNAME";
    CompanyLoginValidationMessageKey["REQUIRED_PASSWORD"] = "REQUIRED_PASSWORD";
})(CompanyLoginValidationMessageKey || (CompanyLoginValidationMessageKey = {}));
export class CompanyLoginDto {
}
__decorate([
    IsString({ message: CompanyLoginValidationMessageKey.REQUIRED_COMPANY_ID }),
    IsNotEmpty({
        message: CompanyLoginValidationMessageKey.REQUIRED_COMPANY_ID,
    }),
    __metadata("design:type", String)
], CompanyLoginDto.prototype, "companyId", void 0);
__decorate([
    IsString({
        message: CompanyLoginValidationMessageKey.REQUIRED_COMPANY_PASSWORD,
    }),
    IsNotEmpty({
        message: CompanyLoginValidationMessageKey.REQUIRED_COMPANY_PASSWORD,
    }),
    __metadata("design:type", String)
], CompanyLoginDto.prototype, "companyPassword", void 0);
__decorate([
    IsString({ message: CompanyLoginValidationMessageKey.REQUIRED_USERNAME }),
    IsNotEmpty({
        message: CompanyLoginValidationMessageKey.REQUIRED_USERNAME,
    }),
    __metadata("design:type", String)
], CompanyLoginDto.prototype, "username", void 0);
__decorate([
    IsString({ message: CompanyLoginValidationMessageKey.REQUIRED_PASSWORD }),
    IsNotEmpty({
        message: CompanyLoginValidationMessageKey.REQUIRED_PASSWORD,
    }),
    __metadata("design:type", String)
], CompanyLoginDto.prototype, "password", void 0);
